import React, { Component } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';
import { propTypes } from '../../util/types';
import { getFirstLocationPart, obfuscatedCoordinates } from '../../util/maps';
import { IconCrionTravel, IconRoute, Map, IconArrowHead } from '../../components';

import css from './ListingPage.module.css';

const capFirst = s => (s && typeof s === 'string' ? s.charAt(0).toUpperCase() + s.slice(1) : s);

class SectionMapMaybe extends Component {
  constructor(props) {
    super(props);
    this.state = { isStatic: true, showPOIs: false };
  }

  togglePOIs = event => {
    this.setState(
      prevState => ({ showPOIs: !prevState.showPOIs }),
      () => {
        // If we just closed the dropdown, blur the button to restore hover
        if (!this.state.showPOIs && event && event.currentTarget) {
          event.currentTarget.blur();
        }
      }
    );
  };

  render() {
    const { className, rootClassName, geolocation, publicData, listingId, mapsConfig } = this.props;

    if (!geolocation) {
      return null;
    }

    const { city, meetingLocation, activityLocation, relatedLocations = [] } = publicData || {};

    const classes = classNames(rootClassName || css.sectionMap, className);
    const cacheKey = listingId ? `${listingId.uuid}_${geolocation.lat}_${geolocation.lng}` : null;

    const mapProps = mapsConfig.fuzzy.enabled
      ? { obfuscatedCenter: obfuscatedCoordinates(geolocation, mapsConfig.fuzzy.offset, cacheKey) }
      : { address: meetingLocation, center: geolocation };
    const map = <Map {...mapProps} useStaticMap={this.state.isStatic} />;

    return (
      <div className={classes}>
        <h2 className={css.locationTitle}>
          <FormattedMessage id="ListingPage.locationTitle" />
        </h2>
        <div className={css.locations}>
          <div className={css.iconTextWrapper}>
            <IconCrionTravel />
            {city || getFirstLocationPart(meetingLocation)}
          </div>
          <div className={css.iconTextWrapper}>
            <IconRoute />
              {capFirst(activityLocation)}
          </div>
        </div>
        {this.state.isStatic ? (
          <button
            className={css.map}
            onClick={() => {
              this.setState({ isStatic: false });
            }}
          >
            {map}
          </button>
        ) : (
          <div className={css.map}>{map}</div>
        )}
        {relatedLocations.length > 0 && (
          <div className={css.poiSection}>
            <button
              className={classNames(css.poiToggle, { [css.poiToggleOpen]: this.state.showPOIs })}
              onClick={this.togglePOIs}
              type="button"
            >
              <span className={css.poiTitleText}>
                <FormattedMessage id="ListingPage.poi" defaultMessage="Points of Interest" />
              </span>
              <span className={css.poiArrow}>
                <IconArrowHead direction={this.state.showPOIs ? 'up' : 'down'} />
              </span>
            </button>
            {this.state.showPOIs && (
              <ul className={css.poiList}>
                {relatedLocations.map((poi, idx) => (
                  <li key={idx}>{poi.name}</li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    );
  }
}

SectionMapMaybe.defaultProps = {
  rootClassName: null,
  className: null,
  geolocation: null,
  listingId: null,
};

SectionMapMaybe.propTypes = {
  rootClassName: string,
  className: string,
  geolocation: propTypes.latlng,
  listingId: propTypes.uuid,
};

export default SectionMapMaybe;
